import { Button } from 'antd';
import { useContext } from 'react';

import './CustomerLeadStepLayoutNextButton.scss';

import { CustomersContext } from 'src/pages/CustomersPage/CustomersPage.context';

export function CustomerLeadStepLayoutBackButton() {
  const { goBack, isEditing } = useContext(CustomersContext);

  return (
    <Button
      className="flex row nowrap align-items-center"
      type="primary"
      ghost={true}
      disabled={isEditing}
      onClick={goBack}
    >
      Back
    </Button>
  );
}
